import closeButtonImage from "../img/close_button.png"
import messageIcon from "../img/message_icon.png"

import depositImage from "../img/deposit-image.png"
import giftImage from "../img/gift.png"
import questionImage from "../img/question.png"
import supportImage from "../img/support_icon.png"
import "../css/support_active_section_container.css"



function SupportActiveSection({setOpenState}){

    const goToTelegram = (text) => {
        window.open("https://t.me/app_polina_support?text=" + text, "_self")
    }

    return <div className="support-active-section-container">
        <div className="close-button-image-container" onClick={() => setOpenState(false)}>
            <img className="close-button-image" src={closeButtonImage} alt="error" />
        </div>
        <div className="support-subsection">
            <div className="support-section-upper-text-row">
                <div className="message-icon-container">
                    <img className="message-icon" src={messageIcon} alt="error"/>
                </div>
                <div className="support-section-upper-text">Поддержка</div>
            </div>
            <div className="support-text-section">
                <div className="support-text">Если возникли трудности, нажмите
                    на одну из кнопок ниже и мы
                    поможем вам в Telegram
                </div>
            </div>
            <div className="support-card-section">
                <div className="support-card" onClick={() => goToTelegram('Здравствуйте! У меня возникла проблема с пополнением')}>
                    <div className="support-card-image-container deposit-image">
                        <img className="support-card-image" src={depositImage} alt="error"/>
                    </div>
                    <div className="support-card-text-section deposit-text">
                        Проблема с пополнением
                    </div>
                </div>
                <div className="support-card" onClick={() => goToTelegram('Здравствуйте! Мне не пришел бонус')}>
                    <div className="support-card-image-container gift-image">
                        <img className="support-card-image" src={giftImage} alt="error"/>
                    </div>
                    <div className="support-card-text-section gift-text">
                        Не пришёл бонуc
                    </div>
                </div>
                <div className="support-card" onClick={() => goToTelegram('Здравствуйте! У меня возник вопрос по приложению')}>
                    <div className="support-card-image-container question-image">
                        <img className="support-card-image" src={questionImage} alt="error"/>
                    </div>
                    <div className="support-card-text-section question-text">
                        Вопрос по приложению
                    </div>
                </div>
                <div className="support-card" style={{backgroundColor: "#1375E1"}} onClick={() => goToTelegram('Здравствуйте!')}>
                    <div className="support-card-image-container support-image">
                        <img className="support-card-image" src={supportImage} alt="error"/>
                    </div>
                    <div className="support-card-text-section support-text">
                        Перевести на менеджера
                        (Менеджер онлайн)
                    </div>
                </div>
            </div>
        </div>
    </div>

};

export default SupportActiveSection;